import { ProjectInfo } from '@/types/home';

export enum WAVE_NUM {
  OTHERS = 0, // 未开始或第一波进行中
  ONE = 1, // 第一波结算或第二波进行中
  TWO, // 第二波结算
}

export interface Winner extends ProjectInfo {
  waveNum: WAVE_NUM;
}
